// 在此文件定义枚举，然后通过export.default导出，代码生成时可以进行选择，选择后代码生成引擎会自动应用该枚举对字段进行解析

// const <枚举名称> = {
//   <枚举项>: {
//     label: <label>,
//     value: <value>
//   }
// }

const ShipLineTypeEnums = {
  NORMAL: { label: '普通', value: 10 },
  SHIFT_BERTH: { label: '移泊', value: 20 }
}

const ShipLineStatusEnums = {
  SAILING: { label: '进行中', value: 0 },
  COMPLETED: { label: '已完成', value: 10 },
  EXCEPTION: { label: '异常', value: 20 },
  INVALID: { label: '已作废', value: 30 }
}

const VoyageEmptyOverloadStatusEnums = {
  EMPTY: { label: '空载', value: 0 },
  FULL: { label: '重载', value: 5 },
  UNKNOWN: { label: '未知', value: 10 }
}

const ShipLineExceptionStatusEnums = {
  NORMAL: { label: '正常', value: 0 },
  EXCEPTION: { label: '异常', value: 1 }
}

const ShipLineConfirmedStatusEnums = {
  NO: { label: '否', value: 0 },
  YES: { label: '置信', value: 1 }
}

export default {
  ShipLineTypeEnums,
  ShipLineStatusEnums,
  VoyageEmptyOverloadStatusEnums,
  ShipLineExceptionStatusEnums,
  ShipLineConfirmedStatusEnums
}
